import { createContext } from 'react';

/**
 * @internal
 */
var SwitchLayoutGroupContext = createContext({});
export { SwitchLayoutGroupContext };